/* THIS FILE WAS AUTO-GENERATED. DO NOT MODIFY */
/* eslint-disable */
import * as SchemaTypes from '../../../types/graph';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DepressionProfileQueryVariables = SchemaTypes.Exact<{ [key: string]: never; }>;


export type DepressionProfileQuery = { __typename?: 'Query', depression: { __typename?: 'Depression', id: string, diagnosedAt: string | null, severity: string | null, currentlyTreated: boolean | null, everTreated: boolean | null, treatmentEndDate: string | null, numberOfMedications: number | null, psychotherapy: boolean | null, hospitalized: boolean | null, hospitalizedAt: string | null }, currentUser: { __typename?: 'User', id: string, dateOfBirth: string | null } };

export type DepressionValuesFragment = { __typename?: 'Depression', id: string, diagnosedAt: string | null, severity: string | null, currentlyTreated: boolean | null, everTreated: boolean | null, treatmentEndDate: string | null, numberOfMedications: number | null, psychotherapy: boolean | null, hospitalized: boolean | null, hospitalizedAt: string | null };

export const DepressionValuesFragmentDoc = gql`
    fragment DepressionValues on Depression {
  id
  diagnosedAt
  severity
  currentlyTreated
  everTreated
  treatmentEndDate
  numberOfMedications
  psychotherapy
  hospitalized
  hospitalizedAt
}
    `;
export const DepressionProfileDocument = gql`
    query DepressionProfile {
  depression {
    id
    ...DepressionValues
  }
  currentUser {
    id
    dateOfBirth
  }
}
    ${DepressionValuesFragmentDoc}`;
export function useDepressionProfileQuery(baseOptions?: Apollo.QueryHookOptions<DepressionProfileQuery, DepressionProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DepressionProfileQuery, DepressionProfileQueryVariables>(DepressionProfileDocument, options);
      }
export function useDepressionProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DepressionProfileQuery, DepressionProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DepressionProfileQuery, DepressionProfileQueryVariables>(DepressionProfileDocument, options);
        }
export type DepressionProfileQueryHookResult = ReturnType<typeof useDepressionProfileQuery>;
export type DepressionProfileLazyQueryHookResult = ReturnType<typeof useDepressionProfileLazyQuery>;
export type DepressionProfileQueryResult = Apollo.QueryResult<DepressionProfileQuery, DepressionProfileQueryVariables>;